import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { Period } from '../../utils/types';
dayjs.extend(duration);

export const findCurrentPeriod = (periods: Period[], position: number): Period | undefined =>
	periods &&
	periods.find((p) => {
		const periodStart = dayjs.duration(p.startPosition ?? '').asSeconds();
		const periodEnd = dayjs.duration(p.endPosition ?? '').asSeconds();
		return position >= periodStart && position < periodEnd;
	});
